var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChandelierSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBCBCE"
    },
    d: "M411.765,394.17c0,36.621-30.786,66.414-68.627,66.414c-37.842,0-68.628-29.793-68.628-66.414V81.828 H256h-18.511v312.343c0,36.621-30.786,66.414-68.628,66.414c-37.841,0-68.627-29.793-68.627-66.414H63.213 c0,57.035,47.393,103.435,105.648,103.435c36.136,0,68.08-17.863,87.139-45.034c19.058,27.171,51.003,45.034,87.139,45.034 c58.254,0,105.648-46.401,105.648-103.435h-37.022V394.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B7B9"
    },
    d: "M411.765,394.17c0,36.621-30.786,66.414-68.627,66.414c-37.842,0-68.628-29.793-68.628-66.414V81.828 H256c0,0,0,319.917,0,370.745c19.058,27.171,51.003,45.034,87.139,45.034c58.254,0,105.648-46.401,105.648-103.435h-37.022V394.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9A8AE"
    },
    d: "M256,97.996c55.967,0,103.845-34.616,123.404-83.602H132.596 C152.155,63.381,200.033,97.996,256,97.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98989D"
    },
    d: "M256,97.996c55.967,0,103.845-34.616,123.404-83.602H256C256,14.394,256,64.504,256,97.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1CE30"
    },
    d: "M81.724,406.929C36.661,406.929,0,371.043,0,326.931v-74.214h163.447v74.214 C163.447,371.043,126.787,406.929,81.724,406.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E69824"
    },
    d: "M107.233,419.999h-51.02c-6.51,0-11.788-5.278-11.788-11.788v-2.563 c0-6.51,5.278-11.788,11.788-11.788h51.02c6.51,0,11.788,5.278,11.788,11.788v2.563 C119.021,414.721,113.743,419.999,107.233,419.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9BA2C"
    },
    d: "M348.553,326.931v-74.214H512v74.214c0,44.111-36.661,79.998-81.724,79.998 S348.553,371.043,348.553,326.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF8920"
    },
    d: "M404.767,419.999h51.02c6.51,0,11.788-5.278,11.788-11.788v-2.563c0-6.51-5.278-11.788-11.788-11.788 h-51.02c-6.51,0-11.788,5.278-11.788,11.788v2.563C392.979,414.721,398.257,419.999,404.767,419.999z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChandelierSvgrepoCom);
export default __webpack_public_path__ + "static/media/chandelier-svgrepo-com.87cbf65d433d8a3885dcb206c75b9c1c.svg";
export { ForwardRef as ReactComponent };